module.exports = __webpack_public_path__ + "img/tab_img2.2137932c.jpg";